'use client';

type OwnProps = {
  src: string;
  title: string;
};

export default function TekionIframe({ src, title }: OwnProps) {
  return (
    <div className="flex grow flex-col">
      <iframe
        src={src}
        className="h-full w-full grow overflow-hidden border-0"
        title={`${title} Service Scheduling`}
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
        referrerPolicy="no-referrer"
      />
    </div>
  );
}
